import { render } from "./date-range.vue?vue&type=template&id=634ea245&lang=pug"
import script from "./date-range.vue?vue&type=script&setup=true&lang=js"
export * from "./date-range.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__